import { SensorType } from "src/store/api/generatedApi";

export const SENSOR_TYPE_LABEL_KEYS = {
  camera: "camera",
  position_tracker: "sensorTypePositionTracker",
  radio_receiver: "sensorTypeRadioReceiver",
} as const satisfies Record<SensorType, string>;

export const SELECTABLE_SENSOR_TYPES = Object.keys(
  SENSOR_TYPE_LABEL_KEYS
) as SensorType[];
